import Vue from 'vue';
import App from './App.vue';
import vSelect from 'vue-select';
import PulseLoader from 'vue-spinner/src/PulseLoader';

Vue.config.productionTip = false
Vue.component('v-select', vSelect);
Vue.component('pulse-loader', PulseLoader);

new Vue({
  render: h => h(App),
}).$mount('#app')
